import { isFilled } from "@prismicio/helpers";
import * as prismicH from "@prismicio/helpers";
export const EmbedContentBase = ({ items, height, }) => (<>
        {items
        .filter((i) => isFilled.richText(i.embed_link))
        .map((item, index) => (<div className="py-2.5" key={index}>
                    <iframe className="border-0" src={prismicH.asText(item.embed_link)} height={height || ""} width="100%"/>
                </div>))}
    </>);
